import { computed, ref } from '@vue/composition-api'

export function useModal() {
    const visible = ref(false)
    const isVisible = computed(() => visible.value)

    function open(): void {
        visible.value = true
    }

    function close(): void {
        visible.value = false
    }

    function toggle(): void {
        visible.value = !visible.value
    }

    return {
        isVisible,
        open,
        close,
        toggle,
    }
}
